<template>
  <CheckboxGroup
    v-model="model"
    class="formily-checkbox"
    :options="resultOptions"
    :position="position"
    :horizontal="horizontal"
    :hollow-style="hollowStyle"
    @input="handleChecked"
  >
  </CheckboxGroup>
</template>

<script>
import { CheckboxGroup } from '@didi/rich-ui'
export default {
  components: { CheckboxGroup },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    position: {
      type: String,
      default: 'right',
    },
    negateValue: {
      type: Number,
      default: null,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    hollowStyle: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      changeOptions: [],
    }
  },
  computed: {
    model: {
      get() {
        return this.value || []
      },
      set(newVal) {
        this.$emit('input', newVal)
        this.$emit('change', newVal)
      },
    },
    resultOptions: {
      get() {
        if (this.visible && this.model?.length) {
          this.handleChecked(this.model)
        }
        return this.changeOptions?.length ? this.changeOptions : this.options || []
      },
    },
  },
  methods: {
    handleChecked(checkedValues) {
      if (this.negateValue) {
        if (checkedValues?.length === 0) {
          this.changeOptions = this.options?.map(item => ({
            ...item,
            disabled: false,
          }))
        } else {
          const hasOne = checkedValues?.includes(-1) ?? false
          this.changeOptions = this.options?.map(item => ({
            ...item,
            disabled: item.value === -1 ? !hasOne : hasOne,
          }))
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
